<h2 class="secondary">{{ 'global.tip-summary.sub-title' | apContent }}</h2>

<ap-panel>
    <div ap-panel-body>
        <h3 class="secondary">{{ 'financial-obligations.credit-card.title' | apContent }}</h3>
        <ng-container [ngTemplateOutlet]="extraInfo" [ngTemplateOutletContext]="{ tipContent: 'financial-obligations.credit-card.tip' }">
        </ng-container>
    </div>
</ap-panel>

<ap-panel>
    <div ap-panel-body>
        <h3 class="secondary">{{ 'financial-obligations.payment-account-overdraft.title' | apContent }}</h3>
        <ng-container
            [ngTemplateOutlet]="extraInfo"
            [ngTemplateOutletContext]="{ tipContent: 'financial-obligations.payment-account-overdraft.tip' }"
        >
        </ng-container>
    </div>
</ap-panel>

<ap-panel>
    <div ap-panel-body>
        <h3 class="secondary">{{ 'property.renovation.title' | apContent }}</h3>
        <ng-container [ngTemplateOutlet]="extraInfo" [ngTemplateOutletContext]="{ tipContent: 'property.renovation.tip' }"> </ng-container>
    </div>
</ap-panel>

<ng-template #extraInfo let-tipContent="tipContent">
    <p>
        <span class="green-bold-text">{{ 'global.tip.title' | apContent }}</span>

        {{ tipContent | apContent }}
    </p>
</ng-template>
